import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalTabSelect } from "../modals/actionModal";
import { IdMarketCategory } from "./IdMarketCategory";
var _ButtonMarketImprovementFulfillContracts = function (_a) {
    var openMainContractsTab = _a.openMainContractsTab;
    return (React.createElement("div", { className: "button-ribbon" },
        React.createElement(ButtonPrimary, { onClick: openMainContractsTab },
            React.createElement(TextLoca, { id: IdLoca.market_fulfillContracts, className: IdStyles.TextButtonDefault }))));
};
var mapDispatch = function (dispatch) { return ({
    openMainContractsTab: function () { return dispatch(actionModalTabSelect(IdMarketCategory.Main)); },
}); };
export var ButtonMarketImprovementFulfillContracts = connect(undefined, mapDispatch)(_ButtonMarketImprovementFulfillContracts);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/ButtonMarketImprovementFulfillContracts.tsx
// module id = 2707
// module chunks = 3